import { render, staticRenderFns } from "./BlueBadge.vue?vue&type=template&id=352dd479"
import script from "./BlueBadge.vue?vue&type=script&lang=js"
export * from "./BlueBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports